export const loanSubmissionWorkflowKeys = [
  'submit_loan',
  'submit_to_loan_setup',
  'submit_to_underwriter',
  'submit_conditions',
  'submit_cTC_review',
] as const

export const workflowRestrictions: Record<string, string> = {
  // Loan Structure
  loanStructureDataComplete: 'Loan Structure -> Data Complete',
  loanStructurePrice: 'Interest Rate and Base Price is Required',

  // submit_loan
  accountExecutiveRequired: 'Account Executive is Required',
  accountManagerRequired: 'Account Manager is Required',

  dataComplete: 'Loan Application -> Data Complete',
  signApplication: 'Loan Application -> Sign Application',
  assetLiability: 'Loan Application -> Asset & Liability',
  creditScorePull: 'Loan Application -> Pull Credit Score',
  scoreMatch: 'Loan Structure -> Credit Score MisMatch',
  estimateMatch: 'Loan Structure -> Closing Cost Estimate MisMatch',

  loanOfficerRquired: 'Parties -> Loan Officer is Required',
  loanProcessorRequired: 'Parties -> Loan Processor is Required',
  titleCompanyRequired: 'Parties -> Title Company is Required',
  hazardCompanyRequired: 'Parties -> Hazard Insurance Company is Required',
  scopeOfWork: `The submission of the Borrower's Budget & Scope of Work Form is required`,

  // submit_to_loan_setup
  submitToLoanSetupRequired: 'Submit to Loan Setup is Required',
  taskClearedRequired: 'Task Generated from "Submit Loan" must be cleared',

  // submit_to_underwriter
  conditionTemplateRequired: 'Condition Template is Required',
  underwriterRequired: 'Underwriter is Required',

  estimatedClosingDateRequired: 'Closing Date is Required',

  ineligibleFlagsCleared: 'All Flags to be cleared',
  ineligiblePartiesCleared: 'Ineligible parties',

  loanMustbeLocked: 'Loan must be locked',

  borrowerHasSignedTermSheet: 'Loan Structure -> Borrower Has Signed Term Sheet',

  asIsValueLessThanAsIsAppraisedValue: 'As-Is Value must be less than or equal to As-Is Appraised Value',
  afterRepairValueLessThanAfterRepairAppraisedValue:
    'After-Repair Value must be less than or equal to After-Repair Appraised Value',
}
